/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__customer-service-products/src/__generated__/ProductsAppQuery$parameters.ts';
import type { ProductsAppQuery } from '@jira/servicedesk__customer-service-products/src/__generated__/ProductsAppQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const PRODUCTS_PAGE_SIZE = 50;

type CustomerServiceProductsEntryPointComponent = EntryPointComponent<
	{
		ProductsAppQuery: ProductsAppQuery;
	},
	{},
	{},
	{} | null
>;

export const customerServiceProductsEntryPoint: EntryPoint<
	CustomerServiceProductsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CustomerServiceProductsEntryPointComponent>(
		/* webpackChunkName: "async-customer-service-products" */ './CustomerServiceProductsSpaApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => ({
		queries: {
			ProductsAppQuery: {
				parameters,
				variables: {
					cloudId,
					first: PRODUCTS_PAGE_SIZE,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
